angular.module("app").controller("UsersListPageController", [
    '$scope',
    'preloadedUsersList',
    'userService',
    'errorHandler',
    'logger',
    '$timeout',
    'userStatuses',
    '$state',
    'pagination',
    function ($scope, preloadedUsersList, userService, errorHandler, logger, $timeout, userStatuses, $state, pagination) {
        var pendingListRequest;

        preloadedUsersList = preloadedUsersList || {};

        $scope.filterOptions = {
            status: userStatuses[0]
        };

        $scope.users = angular.copy(preloadedUsersList.users);

        $scope.userStatuses = angular.copy(userStatuses);

        $scope.pagination = pagination.init(function () {
                !!pendingListRequest && $timeout.cancel(pendingListRequest);
                pendingListRequest = $timeout(function () {
                    $scope.updateList({
                        current_page: $scope.pagination.page,
                        limit: $scope.pagination.limit
                    })
                }, 300);
            }, preloadedUsersList.total_count);

        $scope.getDateTime = function (dateString) {
            return (dateString) ? new Date(dateString).getTime() : ""
        };

        $scope.deleteUser = function (user) {
            var requestData = {
                id: user.id
            };

            userService.deleteUserById(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.updateList();
                        logger.logSuccess("User has been successfully archived");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.updateList = function (externalOptions) {
            var requestObject = {
                status: $scope.filterOptions.status,
                limit: $scope.pagination.limit
            };
            if (!!externalOptions) {
                angular.extend(requestObject, externalOptions)
            }
            userService.getAllUsers(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.users = angular.copy(response.users)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.publishUser = function (user) {
            var requestData = {
                user: {
                    id: user.id,
                    status: "published"
                }
            };

            userService.editUser(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.updateList();
                        logger.logSuccess("User has been successfully published");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.editUser = function (user) {
            $state.go("main.users.edit", {userId: user.id});
        }
    }
]);